<template>
  <div>
    <div class="question-overlay question-overlay--left">
      <img :src="`${assetPath}lockup-overlays/quiz_06-overlay--left@2x.png`" alt="">
    </div>
    <div class="accessible-text">
      <p>Our Employees Go Off-Site on the Regular for Their $5 Coffee Fix:</p>
    </div>
    <transition name="fade">
      <div :class="{ 'transitioned-in': initialized }">
        <div class="svg-wrapper">
          <OffSite class="offsite" />
        </div>
        <div class="svg-wrapper">
          <OffSiteMobile class="offsite--mobile" />
        </div>
        <form class="buttons">
          <template v-for="(question, index) in questions">
            <div :key="index">
              <input type="radio" :id="question.id" name="offsite" :value="question.value" @click="formInteraction(question.value)" :checked="question.value === offsite">
              <label :for="question.id"><span v-html="question.label"></span></label>
            </div>
          </template>
        </form>
      </div>
    </transition>
    <div class="question-overlay question-overlay--right">
      <img :src="`${assetPath}lockup-overlays/quiz_06-overlay--right@2x.png`" alt="">
    </div>
    <div class="question-overlay question-overlay--bottom">
      <img :src="`${assetPath}lockup-overlays/quiz_06-overlay--bottom@2x.png`" alt="">
    </div>
  </div>
</template>

<script>
import { next } from './../../mixins/next.js'
import { assetPath } from './../../mixins/assetPath.js'
import OffSite from '@/assets/offsite.svg'
import OffSiteMobile from '@/assets/offsite--mobile.svg'

export default {
  name: 'QOffsite',
  components: {
    OffSite,
    OffSiteMobile
  },
  props: {
    initialized: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      offsite: this.$store.state.quiz.offsite,
      questions: [
        {
          id: 'true',
          value: true,
          label: 'True'
        },
        {
          id: 'false',
          value: false,
          label: 'False'
        },
      ]
    }
  },
  methods: {
    formInteraction(value) {
      this.offsite = value
      this.next('offsite', this.offsite)
    }
  },
  mixins: [next, assetPath]
}
</script>

<style lang="scss">

.offsite {
  display: none;
  @include breakpoint(large) {
    display: block;
  }
}
.offsite--mobile {
  display: block;
  @include breakpoint(large) {
    display: none;
  }
}

.question--question-six {
  // background-image: url($q6bgMobile);
  background-size: cover;
  width: 100%;
  .svg-wrapper {
    width: 100%;
    position: relative;
    top: -12vw;
  }
  // .question-overlay--left {
  //   width: 100%;
  //   bottom: auto;
  //   right: 0;
  // }
  // .question-overlay--right {
  //   width: 100%;
  //   left: 0;
  //   top: auto;
  // }
  .question-overlay--bottom {
    bottom: -8%;
  }
  @include breakpoint(large) {
    .svg-wrapper {
      width: 77.5%;
      top: -2vw;
      svg {
        height: 30vw; // for IE
      }
    }
    // background-image: url($q6bgDesktop);
  }
  .buttons {
    left: 0;
    right: 0;
    bottom: 26%; // proto
    width: 92%;
    margin: 0 auto;
    padding-right: 1%;
    div {
      width: 50%;
      margin-right: -3px;
    }
    @include breakpoint(large) {
      bottom: 12%;
      width: 64%;
      padding-left: 3.25%;
      display: flex; // restore
      label {
        padding: 0.5em 1.5em;
      }
    }
  }
}

</style>